import definiciones from "./definiciones";
import formulas from "./formulas";
import maestros from "./maestros";

export default {
  definiciones,
  formulas,
  maestros,
};
